'use client';
import { chiliPayUserApi, type PutUserMeAddressData, type PutUserMeAddressPayload } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

const UseUpdateUserAddressQueryKey = ['update-user-address'];

export const useUpdateUserAddress = () => {
	const { data, error, isPending, isSuccess, mutate, mutateAsync } = useMutation<
		PutUserMeAddressData,
		Error,
		PutUserMeAddressPayload
	>({
		mutationFn: async (addressData: PutUserMeAddressPayload) =>
			(await chiliPayUserApi).putUserMeAddress(addressData),
		mutationKey: UseUpdateUserAddressQueryKey
	});

	return {
		data,
		error,
		isLoading: isPending,
		isSuccess,
		mutate,
		mutateAsync
	};
};
